import http from '@/api/common'

export default {
  getAllDeviceTypes() {
    return http.get('devicetype/GetAllDeviceTypes')
  },

  getDeviceTypeImage(id) {
    return http.get(`devicetype/GetDeviceTypeImage/${id}`, {
      responseType: 'blob'
    })
  },

  upsertDeviceType(deviceType) {
    const formData = new FormData()

    // Add Id (null for insert, actual Id for updates)
    if (deviceType.id) {
      formData.append('Id', deviceType.id)
    }

    formData.append('Description', deviceType.description)
    formData.append('ExternalName', deviceType.externalName || '')
    formData.append('RemoteProAlias', deviceType.remoteProAlias || '')
    formData.append('LaunchAlias', deviceType.launchAlias || '')
    formData.append('RepairifyAlias', deviceType.repairifyAlias || '')
    formData.append('RedAlias', deviceType.redAlias || '')
    formData.append(
      'RAGEnabled',
      deviceType.ragEnabled !== undefined ? deviceType.ragEnabled : false
    )
    formData.append(
      'IsAlphanumericSerial',
      deviceType.isAlphanumericSerial !== undefined ? deviceType.isAlphanumericSerial : false
    )

    // Add the image if provided
    if (deviceType.imageFile) {
      formData.append('ImageFile', deviceType.imageFile)
    }

    // Add DeletedDate if exists (for delete/undelete)
    if (deviceType.deletedDate) {
      formData.append('DeletedDate', deviceType.deletedDate)
    }

    return http.post('devicetype/UpsertDeviceType', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/deviceTypes.js